import { Icon } from 'antd';
import React, { useState, useEffect } from 'react';
import { proceedProof } from '../../../../../utils/services/statusMonitoringAPI';
import { ProofViewer } from '../../BatchJobs/components/ProofViewer';

const ProofsTab = ({ batch }) => {
  const [proffDataList, setProffDataList] = useState();

  const [totalProofCount, setTotalProofCount] = useState(0);
  const [proofsApproved, setProofsApproved] = useState(false);
  useEffect(() => {
    const getProofsInfo = async () => {
      const payload = {
        search: [
          {
            fieldName: 'stage',
            value: 'yet_to_start',
          },
          {
            fieldName: 'channel',
            value: batch?.channelType?.toLowerCase(),
          },
        ],
        jobId: batch?.id,
      };
      const response = await proceedProof(payload);
      setProffDataList(response?.data);
      setTotalProofCount(response?.dataCount);
    };

    getProofsInfo();
  }, []);

  return (
    <div>
      {batch?.jobDetails?.proofs && batch?.jobDetails.proofs.length > 0 ? (
        // <ProofViewer
        //     format={batch.deliveryChannel || 'PRINT'}
        //     selectedTemplate={batch.template}
        //     templates={[]}
        //     onApprove={() => { }}
        //     isApproved={true}
        //     proofs={batch.jobDetails.proofs}
        // />
        <></>
      ) : (
        <div style={{ textAlign: 'center', padding: '3rem 0' }}>
          <ProofViewer
            format={batch?.channelType}
            proffDataList={proffDataList}
            setProffDataList={setProffDataList}
            totalProofCount={totalProofCount}
            setTotalProofCount={setTotalProofCount}
            proofsApproved={proofsApproved}
            setProofsApproved={setProofsApproved}
          />
          {/* <Icon
            type="info-circle"
            style={{ fontSize: '48px', color: '#d1d5db', marginBottom: '1rem' }}
          />
          <p style={{ color: '#6b7280' }}>No proofs available for this job</p> */}
        </div>
      )}
    </div>
  );
};

export default ProofsTab;
